import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["purchaserEmailInput", "purchaserEmailError", "recipientEmailInput", "recipientEmailError",
        "recipientMessageInput", "recipientMessageError"];

    connect() {
        this.purchaserEmailInputTarget.value = this.purchaserEmail;
        this.recipientMessageInputTarget.value = this.recipientMessage;
        this.recipientEmailInputTarget.value = this.recipientEmail;
    }

    get purchaserEmail() {
        return this.data.get("purchaserEmail");
    }

    set purchaserEmail(email) {
        this.data.set("purchaserEmail", encodeURIComponent(email));
        this.publishPurchaserEmailUpdatedEvent();
    }

    get recipientEmail() {
        return this.data.get("recipientEmail");
    }

    set recipientEmail(email) {
        this.data.set("recipientEmail", encodeURIComponent(email));
        this.publishRecipientEmailUpdatedEvent();
    }

    get recipientMessage() {
        return this.data.get("recipientMessage");
    }

    set recipientMessage(message) {
        this.data.set("recipientMessage", message);
        this.publishRecipientMessageUpdatedEvent();
    }

    purchaserEmailInputUpdated() {
        let input = this.purchaserEmailInputTarget.value.trim();
        this.purchaserEmail = this.validateEmailAddress(input, this.purchaserEmailErrorTarget) ? input : "";
    }

    recipientEmailInputUpdated() {
        let input = this.recipientEmailInputTarget.value.trim();
        this.recipientEmail = this.validateEmailAddress(input, this.recipientEmailErrorTarget) ? input : "";
    }

    recipientMessageInputUpdated() {
        let input = this.recipientMessageInputTarget.value.trim();
        let isValid = this.validateMessage(input, this.recipientMessageErrorTarget);
        this.recipientMessage = isValid ? input : "";
        this.publishRecipientMessageUpdatedEvent(this.recipientMessage, isValid);
    }

    publishRecipientEmailUpdatedEvent() {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("recipient-email-updated", true, true, null);
        event.recipientEmail = this.recipientEmail;
        this.element.dispatchEvent(event);
    }

    publishPurchaserEmailUpdatedEvent() {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("purchaser-email-updated", true, true, null);
        event.purchaserEmail = this.purchaserEmail;
        this.element.dispatchEvent(event);
    }

    publishRecipientMessageUpdatedEvent(recipientMessage, isValid) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("recipient-message-updated", true, true, null);
        event.recipientMessage = recipientMessage;
        event.isInError = !isValid;
        this.element.dispatchEvent(event);
    }

    validateMessage(message, errorTarget) {
        if (message.length >= 320) {
            this.showError(errorTarget, this.data.get('max-character-error'));
            return false;
        } else if (!this.validateMessageString(message)) {
            this.showError(errorTarget, this.data.get('invalid-message-error'))
        } else {
            this.hideError(errorTarget);
            return true;
        }
    }

    validateEmailAddress(email, errorTarget) {
        if (email == "") {
            this.showError(errorTarget, this.data.get('required-error'));
            return false;
        } else if (!this.validateEmailString(email)) {
            this.showError(errorTarget, this.data.get('invalid-email-error'));
            return false;
        } else {
            this.hideError(errorTarget);
            return true;
        }
    }

    validateEmailString(email) {
        var reValidEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isValid = reValidEmail.test(email) && !this.hasEmojis(email);
        return isValid;
    }

    validateMessageString(message) {
        var reNewlinesAndTabs = /[\n\t]/;
        let isNotValid = reNewlinesAndTabs.test(message) || this.hasEmojis(message);
        return !isNotValid;
    }

    hasEmojis(string) {
        var reHasEmojis = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/
        return reHasEmojis.test(string);
    }

    showError(errorTarget, errorMessage) {
        errorTarget.innerHTML = errorMessage;
        errorTarget.classList.toggle('hidden', false);
    }

    hideError(errorTarget) {
        errorTarget.innerHTML = "";
        errorTarget.classList.toggle('hidden', true);
    }
}
